// document.addEventListener('DOMContentLoaded', function () {
//   const storeDomain = 'aufero-laser.myshopify.com';
//   const storefrontAccessToken = '4074b1212f2b2026002fd2c10cdbb759';

//   const productDropdown = document.querySelector('#productDropdown');
//   const megaMenu = document.querySelector(".mega-menu-container");

//   if (productDropdown && megaMenu) {
//     megaMenu.style.backgroundColor = "#fff";
//     megaMenu.replaceChildren(...productDropdown.children); // 更高效替代 innerHTML
//   }

//   const collections = [
//     { name: 'Laser Engravers', limit: 9 },
//     { name: 'Laser Module Accessories', limit: 4 },
//     { name: 'Accessory', limit: 1 }
//   ];

//   collections.forEach(({ name, limit }) => {
//     fetchCollection(name, limit);
//   });

//   async function fetchCollection(name, limit) {
//     const query = `
//       {
//         collections(first: 1, query: "${name}") {
//           edges {
//             node {
//               title
//               products(first: ${limit}) {
//                 edges {
//                   node {
//                     title
//                     handle
//                     description
//                     images(first: 1) {
//                       edges {
//                         node {
//                           src
//                         }
//                       }
//                     }
//                   }
//                 }
//               }
//             }
//           }
//         }
//       }
//     `;

//     try {
//       const res = await fetch(`https://${storeDomain}/api/2024-10/graphql.json`, {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Shopify-Storefront-Access-Token': storefrontAccessToken
//         },
//         body: JSON.stringify({ query })
//       });

//       const json = await res.json();
//       const collection = json?.data?.collections?.edges?.[0]?.node;
//       if (collection) {
//         renderProducts(collection.products.edges, collection.title);
//       }
//     } catch (err) {
//       console.error(`❌ 获取 ${name} 系列失败:`, err);
//     }
//   }

//   function renderProducts(products, title) {
//     if (!products || !products.length) return;

//     if (title === "Laser Engravers") {
//       renderNewProduct(products[0]);
//       renderList(products.slice(1), ".right_category ul");
//     } else if (title === "Laser Module Accessories") {
//       renderList(products, ".bottom_left ul");
//     } else if (title === "Accessory") {
//       renderList(products, ".bottom_right ul");
//     }
//   }

//   function renderNewProduct(product) {
//     const container = document.querySelector(".recommend");
//     if (!container || !product) return;

//     const link = document.createElement("a");
//     link.href = `https://shop.orturtech.com/products/${product.node.handle}`;
//     link.target = "_blank";

//     const img = document.createElement("img");
//     img.src = product.node.images.edges[0]?.node.src || "";
//     img.alt = product.node.title;
//     img.loading = "lazy";

//     const title = document.createElement("h4");
//     title.textContent = getTitleWithTwoWords(product.node.title);

//     const desc = document.createElement("p");
//     desc.textContent = product.node.description;

//     link.append(document.createElement("span").appendChild(img));
//     link.append(title, desc);
//     container.appendChild(link);
//   }

//   function renderList(products, selector) {
//     const ul = document.querySelector(selector);
//     if (!ul) return;

//     products.forEach(product => {
//       const li = document.createElement("li");

//       const link = document.createElement("a");
//       link.href = `https://shop.orturtech.com/products/${product.node.handle}`;

//       const img = document.createElement("img");
//       img.src = product.node.images.edges[0]?.node.src || "";
//       img.alt = product.node.title;
//       img.loading = "lazy";

//       const title = document.createElement("h4");
//       title.textContent = getTitleWithTwoWords(product.node.title);

//       const span = document.createElement("span");
//       span.appendChild(img);

//       link.append(span, title);
//       li.appendChild(link);
//       ul.appendChild(li);
//     });
//   }

//   function getTitleWithTwoWords(title) {
//     return title.split(' ').slice(0, 2).join(' ').replace(/:/g, '');
//   }
// });


// 配置中心 - 集中管理常量和配置
const XTJJ_CONFIG = {
    storeDomain: 'aufero-laser.myshopify.com',
    accessToken: '4074b1212f2b2026002fd2c10cdbb759',
    apiVersion: '2024-10',
    shopBaseUrl: 'https://shop.orturtech.com/products/',
    collections: [
        { name: 'Laser Engravers', limit: 16, id: 'xtjj-laser-engravers', url: 'https://orturtech.com/collections/laser-engravers' },
        { name: 'Aufero Laser Engravers', limit: 8, id: 'xtjj-aufero-laser-engravers', url: 'https://orturtech.com/collections/aufero-laser-engraving' },
        { name: 'Laser Module Accessories', limit: 4, id: 'xtjj-laser-module-accessories', url: 'https://orturtech.com/collections/laser-module' },
        { name: 'Accessory', limit: 8, id: 'xtjj-accessory', url: 'https://orturtech.com/collections/accessory' },
        { name: 'consumables', limit: 8, id: 'xtjj-consumables', url: 'https://orturtech.com/collections/consumables' }
    ]
};

// 自定义标题映射表：key 是商品的 handle（商品详情页 URL 最后一段），value 是你想显示的文字
// 例如商品链接是 https://orturtech.com/products/ortur-r1 → handle 就是 "ortur-r1"
// 在这里配置的商品，会优先显示自定义标题，不再走"取前两个单词"的默认规则
// 没有在这里配置的商品，仍然自动走默认逻辑（取前两个单词）
const XTJJ_CUSTOM_TITLES = {
    'ortur-r1': 'R1',
    'ortur-r2': 'R2',
    'ortur-laser-master-h10-engraving-cutting-machine': 'H10',
    'ortur-f20pro-laser-engraver-cutter-3w-5w-1-3w': 'F20 Pro',
};

// 产品展示核心逻辑
(function() {
    // DOM 元素缓存
    const elements = {
        navItems: document.querySelectorAll('.xtjj-prodshow-nav-item'),
        productLists: document.querySelectorAll('.xtjj-prodshow-products'),
        title: document.querySelector('.xtjj-prodshow-title'),
        scrollContainers: document.querySelectorAll('[data-xtjj-scroll]')
    };
      const productDropdown = document.querySelector('#xtjj-productDropdown');
      const megaMenu = document.querySelector(".mega-menu-container");

      if (productDropdown && megaMenu) {
        megaMenu.style.backgroundColor = "#fff";
        megaMenu.replaceChildren(...productDropdown.children); // 更高效替代 innerHTML
      }

    // 初始化
    function init() {
        // 加载所有产品集合
        XTJJ_CONFIG.collections.forEach(collection => {
            fetchCollection(collection);
        });
        
        // 初始化默认显示第一个系列
        const defaultCollection = XTJJ_CONFIG.collections[0];
        switchSeries(defaultCollection.id, defaultCollection.url);
        
        // 绑定事件
        bindEvents();
    }

    // 绑定所有事件
    function bindEvents() {
        // 导航项事件（鼠标+键盘）
        elements.navItems.forEach(item => {
            item.addEventListener('mouseenter', handleNavHover);
            item.addEventListener('touchstart', handleNavTouch); // 移动触摸
            item.addEventListener('keydown', handleNavKeydown); // 键盘支持
        });

        // 滚动容器事件
        elements.scrollContainers.forEach(container => {
            container.addEventListener('wheel', handleScroll);
        });
    }

    // 处理导航鼠标悬停
    function handleNavHover(e) {
        const targetId = e.currentTarget.getAttribute('data-xtjj-target');
        const url = e.currentTarget.getAttribute('data-xtjj-url');
        switchSeries(targetId, url);
    }

    // 处理导航触摸事件
    function handleNavTouch(e) {
        e.preventDefault(); // 防止触摸滚动
        const targetId = e.currentTarget.getAttribute('data-xtjj-target');
        const url = e.currentTarget.getAttribute('data-xtjj-url');
        switchSeries(targetId, url);
    }

    // 处理导航键盘事件（Enter/Space）
    function handleNavKeydown(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            const targetId = e.currentTarget.getAttribute('data-xtjj-target');
            const url = e.currentTarget.getAttribute('data-xtjj-url');
            switchSeries(targetId, url);
        }
    }

    // 切换产品系列
    function switchSeries(targetId, url) {
        // 更新导航激活状态
        elements.navItems.forEach(item => {
            item.classList.toggle('xtjj-prodshow-active', 
                item.getAttribute('data-xtjj-target') === targetId);
        });
        
        // 更新产品列表显示
        elements.productLists.forEach(list => {
            list.classList.toggle('xtjj-prodshow-active', list.id === targetId);
        });
        
        // 更新标题和链接
        const seriesName = document.querySelector(`[data-xtjj-target="${targetId}"]`).textContent.trim();
        elements.title.innerHTML = `${seriesName} <a href="${url}" class="prodshow-nav-link">MORE >></a>`;
    }

    // 从Shopify获取产品集合
    async function fetchCollection({ name, limit, id: targetId, url }) {
        const query = `
            {
                collections(first: 1, query: "${name}") {
                    edges {
                        node {
                            title
                            products(first: ${limit}) {
                                edges {
                                    node {
                                        title
                                        handle
                                        description
                                        images(first: 1) {
                                            edges {
                                                node {
                                                    src
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        `;

        try {
            const res = await fetch(
                `https://${XTJJ_CONFIG.storeDomain}/api/${XTJJ_CONFIG.apiVersion}/graphql.json`, 
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Shopify-Storefront-Access-Token': XTJJ_CONFIG.accessToken
                    },
                    body: JSON.stringify({ query })
                }
            );

            if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
            
            const json = await res.json();
            
            const collection = json?.data?.collections?.edges?.[0]?.node;
            if (collection) {
                renderProducts(collection.products.edges, targetId);
            } else {
                showError(targetId, `未找到${name}系列产品`);
            }
        } catch (err) {
            console.error(`❌ 获取 ${name} 系列失败:`, err);
            showError(targetId, `加载失败，请重试`);
        }
    }

    // 渲染产品列表（使用DocumentFragment优化性能）
    function renderProducts(products, targetId) {
        const container = document.querySelector(`#${targetId} .xtjj-prodshow-products-inner`);
        if (!container || !products?.length) return;
        
        // 清空加载状态
        container.innerHTML = '';
        container.classList.remove('xtjj-prodshow-loading');
        
        // 使用文档片段减少DOM重绘
        const fragment = document.createDocumentFragment();
        
        products.forEach(product => {
            const productNode = product.node;
            if (!productNode) return;
            
            // 创建产品卡片
            const card = document.createElement('div');
            card.className = 'xtjj-prodshow-product-card';
            
            // 产品链接
            const link = document.createElement('a');
            link.href = `${XTJJ_CONFIG.shopBaseUrl}${productNode.handle}`;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            
            // 产品图片
            const imgContainer = document.createElement('div');
            imgContainer.className = 'xtjj-prodshow-product-img-container';
            
            const img = document.createElement('img');
            img.className = 'xtjj-prodshow-product-img';
            img.src = productNode.images.edges[0]?.node.src || '';
            img.alt = productNode.title || 'Product image';
            img.loading = 'lazy'; // 懒加载优化
            
            // 产品名称（优先使用自定义标题映射表，否则走默认截取逻辑）
            const name = document.createElement('h4');
            name.className = 'xtjj-prodshow-product-name';
            name.textContent = getShortTitle(productNode.title, productNode.handle);
            
            // 产品描述
            const desc = document.createElement('p');
            desc.className = 'xtjj-prodshow-product-desc';
            if (productNode.description?.trim()) {
                desc.textContent = productNode.description.substring(0, 30);
            }
            
            // 组装DOM
            imgContainer.appendChild(img);
            link.append(imgContainer, name, desc);
            card.appendChild(link);
            fragment.appendChild(card);
        });
        
        // 一次性插入DOM
        container.appendChild(fragment);
    }

    // 显示错误信息
    function showError(targetId, message) {
        const container = document.querySelector(`#${targetId} .xtjj-prodshow-products-inner`);
        if (container) {
            container.innerHTML = message;
            container.classList.remove('xtjj-prodshow-loading');
            container.style.display = 'flex';
            container.style.alignItems = 'center';
            container.style.justifyContent = 'center';
            container.style.height = '200px';
        }
    }

    // 处理横向滚动
    function handleScroll(e) {
        e.preventDefault();
        // 根据滚轮力度调整滚动距离（更自然的滚动体验）
        const scrollAmount = e.deltaY * 0.5; // 减缓滚动速度
        e.currentTarget.scrollLeft += scrollAmount;
    }

    // 获取展示标题：优先使用 XTJJ_CUSTOM_TITLES 里的自定义映射，
    // 没有配置的商品则走默认逻辑——截取标题前两个单词
    function getShortTitle(title, handle) {
        //console.log('商品标题:', title, '| handle:', handle); // 调试用，确认后可删除
        if (handle && XTJJ_CUSTOM_TITLES[handle]) {
            return XTJJ_CUSTOM_TITLES[handle];
        }
        if (!title) return '';
        var cleaned = title.replace(/^Ortur\s+/i, '');
        return cleaned.split(' ').slice(0, 2).join(' ').replace(/:/g, '');
    }

    // 初始化执行
    init();
})();
